import { render, staticRenderFns } from "./Acceso.vue?vue&type=template&id=2c00732e&scoped=true&"
import script from "./Acceso.vue?vue&type=script&lang=js&"
export * from "./Acceso.vue?vue&type=script&lang=js&"
import style0 from "./Acceso.vue?vue&type=style&index=0&id=2c00732e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00732e",
  null
  
)

export default component.exports